import { SelectInput } from "../../../components/SelectInput/SelectInput";

const sortOptions = [
    { label: "Newest", value: "newest" },
    { label: "Oldest", value: "oldest" },
];

export function ListActionBar({count, onSortChange, sort}: {count: number, onSortChange: (sort: string) => void, sort: string}) {
    const sessionLabel = count === 1 ? "Session" : "Sessions";
    return (
        <div className="w-full flex justify-between items-center">
            <div className="text-gray-601 text-[clamp(12px,1.5vw,13px)] font-semibold">{count} {sessionLabel}</div>
            <div>

            <SelectInput
                        containerClassName="w-[110px]"
                        options={sortOptions}
                        placeholder="Sort by"
                        className="w-full text-[clamp(12px,1.5vw,14px)] px-3 font-semibold h-full min-h-[27px] w-[110px] rounded-full outline-none !border-none bg-gray-100"
                        value={sort}
                        onChange={(e) => onSortChange(e.target.value)}
                    />
            </div>
        </div>
    );
}